"use client";

import { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useRouter } from "next/navigation";

const ReportDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [windowWidth, setWindowWidth] = useState(0);

  const router = useRouter();

  useEffect(() => {
    // Set initial window width
    setWindowWidth(window.innerWidth);
    
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchTests = async () => {
      setLoading(true);
      try {
        const response = await fetch(`/api_h/test_report_formats`);
        const data = await response.json();

        const sortedData = data.sort((a, b) =>
          a.test_name.localeCompare(b.test_name, undefined, {
            sensitivity: "base",
            numeric: true,
          })
        );

        setTests(sortedData);
      } catch (err) {
        setError("Failed to fetch test data");
        console.error("Error fetching tests:", err);
      }
      setLoading(false);
    };

    fetchTests();
  }, []);

  const handleTestClick = (testName) => {
    // Properly encode the test name for URL
    const encodedName = encodeURIComponent(testName);
    console.log("Navigating to:", `/test/${encodedName}`);
    router.push(`/test/${encodedName}`);
  };

  // Don't render until we have window width
  if (typeof window === 'undefined' || windowWidth === 0) {
    return null;
  }

  return (
    <div
      className={`absolute top-1/2 right-0 transform -translate-y-1/2 ${isOpen ? 'z-[1000]' : 'z-0'}`}
    >
      <div className="flex">
        {/* Toggle Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex flex-col items-center px-1 py-[145px] min-h-[720px] w-5 bg-blue-500 text-white hover:bg-blue-600 rounded-r-none"
        >
          <div className="flex flex-col items-center gap-2">
            <div className="mt-[-50px] mb-[50px]">
              {isOpen ? <FaChevronRight /> : <FaChevronLeft />}
            </div>
            {"REPORT  FORMATS".split("").map((letter, index) => (
              <div key={index}>
                <p className="text-sm mt-1">{letter}</p>
              </div>
            ))}
          </div>
        </button>

        {/* Drawer Panel */}
        <div
          className={`bg-white shadow-lg border-l border-gray-200 transition-all duration-300 overflow-hidden`}
          style={{
            width: isOpen
              ? windowWidth >= 768
                ? "1200px"
                : "335px"
              : "0",
            height: windowWidth >= 768 ? "720px" : "1220px",
          }}
        >
          <div className="p-4 h-full overflow-y-auto">
            {loading ? (
              <div className="flex items-center justify-center h-full">
                <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-blue-500"></div>
              </div>
            ) : error ? (
              <div className="flex items-center justify-center h-full">
                <p className="text-red-500">{error}</p>
              </div>
            ) : (
              <div
                className={`grid gap-3 ${windowWidth >= 768 ? "grid-cols-5" : "grid-cols-2"}`}
              >
                {tests.map((test, index) => (
                  <button
                    key={index}
                    onClick={() => handleTestClick(test.test_name)}
                    className={`text-left py-2 px-3 h-[60px] text-blue-500 border rounded-md border-gray-300 ${index % 2 === 0 ? "bg-gray-200" : "bg-blue-100"
                      } hover:bg-white`}
                    title={test.test_description}
                  >
                    {test.test_name}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportDrawer;